import { type Common } from './common.js';
import type * as Places from './models/places.js';

/**
 * Opaque token the client generates to group one address entry's Autocomplete
 * and Place Details calls into a single billed Google session.
 *
 * NOT a security token. It is created and sent by the browser, so the server
 * treats it as untrusted: it may be absent, an invalid or nil UUID, or reused
 * across users. It only affects Google session billing.
 */
export type ClientSessionToken = string;

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findTextSearchSuggestions(args: {
    input: string;
    kind?: Places.Kind;
    latitude?: number | null;
    longitude?: number | null;
  }): Promise<Places.PlaceSuggestion[]> {
    const url = this.common.constructPath('/patient-previsit/places/text-search', args);

    return await this.common.getJSON(url);
  }

  async findAutocompleteSuggestions(args: {
    input: string;
    practiceId?: string;
    latitude?: number;
    longitude?: number;
    clientSessionToken?: ClientSessionToken;
  }): Promise<Places.PlaceSuggestion[]> {
    const url = this.common.constructPath('/patient-previsit/places/autocomplete', args);

    return await this.common.getJSON(url);
  }

  async findPlaceDetails(args: {
    placeId: string;
    clientSessionToken?: ClientSessionToken;
  }): Promise<Places.PlaceDetails> {
    const url = this.common.constructPath('/patient-previsit/places/details', args);

    return await this.common.getJSON(url);
  }
}
